import Story from "./Story";

export default class StoryFactory {

    createStory(data) {
        return new Story(data);
    }
    
    static createStory(data) {
        return new Story(data);
    }
}
